import { Grid, Select } from '@mui/material';
import { HSpacer, RoutalPalette, SMPalette } from '@nx-smartmonkey/ui';
import React from 'react';
import styled from 'styled-components';

import RoutalIcon from '../../../../assets/svg/RoutalIcon';
import { ProjectCustomersStyle } from '../../../../domain/project/projectCustomers/style/ProjectCustomersStyle';
import Text from '../../../../react-components/Text';

export const NotificationsEmailContainer = styled.div`
  min-width: 300px;
  color: #333940;
  background-color: ${SMPalette.grey2};
  height: 100%;
`;

export const NotificationsEmailContainerHeader = styled.div`
  padding: 16px 26px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 38px;
  background-color: ${RoutalPalette.white};
  justify-content: space-between;
  border-bottom: 1px solid ${RoutalPalette.neutral10};
`;

export const NotificationsEmailContainerBody = styled.div`
  display: flex;
  flex-direction: column;
  background-color: transparent;
  border: 1px solid ${RoutalPalette.neutral10};
  border-radius: 4px;
  background-color: ${RoutalPalette.white};
  min-height: 580px;
  height: calc(100% - 2px);
`;

export const NotificationsEmailBody = styled.div`
  width: 100%;
  max-width: 550px;
  background-color: ${RoutalPalette.white};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
`;

const NotificationsEmailBodyFooterStyled = styled(Grid)`
  height: 46px;
  width: 100%;
  margin-top: 20px;
  background-color: ${RoutalPalette.primary60};
  border: 1px solid ${RoutalPalette.primary60};
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  text-align: center;
  vertical-align: middle;
`;

export const NotificationsEmailBodyFooter = ({ customersStyle }: { customersStyle: ProjectCustomersStyle }) => {
  return (
    <NotificationsEmailBodyFooterStyled style={{}} container alignItems="center" justifyContent="center">
      {customersStyle.show_powered_by ? (
        <>
          <RoutalIcon color={RoutalPalette.white} />
          <HSpacer small />
          <Text style={{ color: RoutalPalette.white, fontSize: `11px` }}>Powered by Routal ®</Text>
        </>
      ) : null}
    </NotificationsEmailBodyFooterStyled>
  );
};

export const PodSelect = styled(Select)`
  width: 200px;
  .MuiSelect-select {
    padding: 8px;
  }
`;

export const AttachmentItem = ({ children }: React.PropsWithChildren<{}>) => {
  return (
    <div
      style={{
        width: `135px`,
        height: `90px`,
        position: `relative`,
        backgroundColor: RoutalPalette.neutral00,
      }}
    >
      <div
        style={{
          width: `100%`,
          height: `100%`,
          border: `1px solid ${RoutalPalette.secondary20n}`,
          display: `flex`,
          alignItems: `center`,
          justifyContent: `center`,
        }}
      >
        {children}
      </div>
      <div
        style={{
          width: 0,
          height: 0,
          position: `absolute`,
          borderTop: `20px solid ${RoutalPalette.secondary20n}`,
          borderRight: `20px solid ${RoutalPalette.white}`,
          right: `-2px`,
          bottom: `-2px`,
        }}
      />
    </div>
  );
};
